import React from 'react'

export function OrangeCircleIcon (): React.JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14ZM7.65625 3.5V4.15625V7.21875V7.875H6.34375V7.21875V4.15625V3.5H7.65625ZM6.34375 10.0625V8.75H7.65625V10.0625H6.34375Z" fill="#E16642"/>
    </svg>
  )
}
